// extracted by mini-css-extract-plugin
export default {"narratives-chat-window":"NarrativesChat_narratives-chat-window__3OVx1"};